import { render, staticRenderFns } from "./dbCompareModalEditComponent.vue?vue&type=template&id=086c3a4e"
import script from "./dbCompareModalEditComponent.vue?vue&type=script&lang=js"
export * from "./dbCompareModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports